import { render } from "./HotelSearchView.vue?vue&type=template&id=89a1f824"
import script from "./HotelSearchView.vue?vue&type=script&lang=js"
export * from "./HotelSearchView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__